export const CmdFournisseurStatus = {
  DESSIN_EN_COURS : 'dessin-en-cours',
  NOUVEL: 'nouvel',
  EN_ATTENTE: 'en-attente',
  EN_COURS: 'en-cours',
  ENVOYE_FABRICANT: 'envoye-fabricant',
  A_SAISIR: 'a-saisir',
  FAILED_CQ : 'failed-cq',
  EN_ETIQUETAGE: 'en-etiquetage',
  A_DISPATCHER_MG : 'a-dispatcher-mg',
  ENVOYE_MG: 'envoye-mg',
  PRETE: 'prete',
  A_EXPEDIE: 'a-expedier',
  EN_STOCK: 'en-stock',
  LIVRE: 'livre',
  FACTURE : 'facture',
  REFUSER: 'refuser',
  ANNULER: 'annuler',
};

export const CmdFournisseurType = {
  COMMANDE_MANUEL: 'commande-manuel',
  COMMANDE_REASSORT: 'commande-reassort',
  COMMANDE_CLIENT: 'commande-client',
};

export const CmdFbStatusBg = {
  ['a-dessiner']: '#9761ce',
  ['nouvel']: '#2196F3',
  ['en-attente']: '#f3ae53',
  ['en-cours']: '#9761cd',
  ['envoye-fabricant']: '#00c875',
  ['a-saisir']: '#f3ae53',
  ['failed-cq']: '#e2445c',
  ['en-etiquetage']: '#f0c523',
  ['a-dispatcher-mg']: '#0484c2',
  ['envoye-mg']: '#00c875',
  ['en-stock']: '#a1d041',
  ['prete']: '#a1d041',
  ['a-expedie']: '#a1d041',
  ['livre']: '#00c875',
};

export const CmdFournisseurTypeOption = [
  'commande-client',
  'commande-reassort',
  'commande-prototype',
];

export const CmdFbStatusDelais = {
  ['nouvel']: 2,
  ['en-attente']: 3,
  ['en-cours']: 30,
  ['envoye-fabricant']: 3,
  ['a-saisir']: 1,
  ['failed-cq']: 7,
  ['en-etiquetage']: 1,
  ['a-dispatcher-mg']: 1,
  ['envoye-mg']: 1,
  ['a-expedie']: 3,
};

export const CmdFbStatusDelaisAccumul = {
  ['nouvel']: 2,
  ['en-attente']: 5,
  ['en-cours']: 35,
  ['envoye-fabricant']: 38,
  ['a-saisir']: 39,
  ['en-etiquetage']: 40,
  ['a-dispatcher-mg']: 41,
  ['envoye-mg']: 42,
  ['a-expedie']: 45,
};


export const cmd_type_bg = {
  'commande-manuel': '#9761cd',
  'commande-reassort': '#00c875',
  'commande-client': '#2196F3',
};